var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ut-mt-8"},[_c('h2',{staticClass:"ut-px-6 ut-text-xs ut-tracking-wide ut-text-neutral-001 ut-opacity-25",domProps:{"textContent":_vm._s(_vm.name)}}),_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }